import { API_BASE_URL } from 'config/api'
import { makeNumbersFarsi } from '../utils/farsi'
import { ImageWithSkeleton } from './ImageWithSkeleton'

type Props = {
  id: string
  productName: string
  author: string
  publisher: string
  translator: string | null
  imageUrl?: string | null
}

export const ProductRequestCard = ({
  id,
  productName,
  author,
  publisher,
  translator,
  imageUrl,
}: Props) => {
  const placeholderImage = '/assets/images/image-placeholder.png'

  return (
    <div
      className='overflow-hidden p-4 rounded-lg flex flex-col justify-between transition-colors duration-300'
      style={{
        backgroundColor: 'var(--card-bg)',
        color: 'var(--text-primary)',
        boxShadow: 'var(--card-shadow)',
        border: '1px solid var(--border-color)',
      }}
    >
      <div>
        <ImageWithSkeleton
          src={
            imageUrl ? `${API_BASE_URL}/files/${imageUrl}` : placeholderImage
          }
          alt={`کاور "${productName}" نویسنده ${author}`}
          containerClassName='h-64 w-full'
          className='w-full h-full object-contain object-center'
        />
        <div className='flex flex-col items-center h-[40%] justify-evenly py-4'>
          <h1 className='w-full text-base font-semibold mt-1 text-center'>
            {makeNumbersFarsi(productName)}
          </h1>
          <h2 className='w-full text-center font-semibold text-base mt-1'>
            {author}
          </h2>
          <p className='w-full text-center text-sm mt-1 text-gray-600 dark:text-gray-400'>
            {publisher}
          </p>
          {translator && (
            <p className='w-full text-center text-sm mt-1 text-gray-600 dark:text-gray-400'>
              مترجم: {translator}
            </p>
          )}
        </div>
      </div>
    </div>
  )
}
